import { render, staticRenderFns } from "./DrawerBurger.vue?vue&type=template&id=022dc87c&scoped=true&"
import script from "./DrawerBurger.vue?vue&type=script&lang=js&"
export * from "./DrawerBurger.vue?vue&type=script&lang=js&"
import style0 from "./DrawerBurger.vue?vue&type=style&index=0&id=022dc87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022dc87c",
  null
  
)

export default component.exports